<template>
<div class="goods"><h3>{{ $$FormData.title || '积分兑换商品' }}</h3><p v-if="$$FormData.show_categories !== false">全部 / 消费积分</p><div class="cards" :class="$$FormData.layout"><div v-for="n in 2" :key="n" class="card"><i class="el-icon-present"></i><div>积分商品示例<p>1000积分 + ¥0.00</p><small v-if="$$FormData.show_original_price !== false">原价：¥100.00</small></div><span>兑换</span></div></div><small>实际展示现有积分活动商品，购买及兑换规则不变</small></div>
</template>
<script>
export default { name: 'PointsGoodsPreview' }
</script>
<style scoped>
.summary { padding: 22px 12px; color: #fff; display: flex; justify-content: space-between; font-size: 12px; }
.summary strong { margin-left: 12px; font-size: 22px; }
.goods,.coupons { background: #fff; padding: 12px; font-size: 12px; }
h3 { margin: 0 0 14px; font-size: 16px; }
p,small { color: #999; } small { font-size: 10px; }
.card,.coupon { display: flex; gap: 12px; align-items: center; padding: 16px 0; border-bottom: 1px solid #eee; }
.card i { font-size: 36px; color: #b69d70; }
.card span,.coupon span { margin-left: auto; padding: 5px 8px; border-radius: 4px; background: #202020; color: #fff; }
.coupon strong { font-size: 26px; color: #b69d70; }
.row-two { display: flex; gap: 8px; }.row-two .card { width: 50%; flex-direction: column; align-items: flex-start; }
</style>
